import {
  ApolloClient, ApolloLink, HttpLink, InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

const uri = process.env.GRAPH_API || '/api/bff/fulfillment';

export default function makeApolloClient(router, options, $location, log) {
  return new ApolloClient({
    credentials: 'same-origin',
    cache: new InMemoryCache(),
    link: ApolloLink.from([
      onError(({
        graphQLErrors,
      }) => {
        log?.error('apollo-client', 'onError', 'graphQLErrors', { graphQLErrors });
        if (Array.isArray(graphQLErrors)) {
          const shouldReload = graphQLErrors.find((error) => (
            error?.extensions?.code === 'UNAUTHENTICATED'
          )) && !$location?.host?.match(/local(.*)?:[0-9]{2,5}$/);
          if (shouldReload) {
            $location?.reload();
          }
        }
      }),
      setContext((_, { headers }) => ({
        headers: {
          ...headers,
          ...options?.headers,
          storeId: router.state.matches[0].params.storeId,
        },
      })),
      new HttpLink({
        uri,
      }),
    ]),
  });
}
